import React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const PrimaryButton = ({ children, className, ...props }) => {
    return (
        <button
            className={twMerge(clsx(
                "bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded text-sm font-bold shadow-lg transition-colors flex items-center gap-2",
                className
            ))}
            {...props}
        >
            {children}
        </button>
    );
};
